/**
 * The HOC is used to generate row data for summary group row. And insert each group row on top of group.
 * @author: Ronan
 * @param: sourceProp {string} prop that needs to be processed.
 * @param: targetProp {string} prop that passed to WrappedComponent
 */
import React, { PureComponent } from 'react';
import Enums from 'utils/EnumsManager';
import { calcValueByType, calcSummary } from '../utils';

const { GROUPS } = Enums.DROPZONES;
const {
  ROWSPERGROUP,
  MAXROWS,
  SUMMARYKEY,
  GROUPROWKEY
} = Enums.REPORTS.PREVIEW;

const insertGroupRows = (sourceProp, targetProp) => WrappedComponent =>
  class extends PureComponent {
    getGroupColumns = () =>
      this.props.columns.filter(col => col.belongTo === GROUPS);
    insertGroupRowsToData = (originalData, groupsData) => {
      groupsData.forEach((g, i) => {
        originalData.splice(i * (ROWSPERGROUP + 1), 0, g);
      });
      return originalData;
    };
    renderGroupRows = () => {
      const groupRows = [];
      const groups = this.getGroupColumns();
      if (groups.length > 0) {
        for (let i = 0; i < MAXROWS / ROWSPERGROUP; i++) {
          let groupRow = {
            [GROUPROWKEY]: true,
            [SUMMARYKEY]: calcSummary(
              this.props[sourceProp],
              this.props.columns,
              i
            )
          };
          // NOTES: this is for future if we have more than one column can be grouped.
          groups.forEach(g => (groupRow[g.name] = calcValueByType(g.type)));
          groupRows.push(groupRow);
        }
      }
      return groupRows;
    };

    render() {
      if (!_.isArray(this.props[sourceProp])) return null;

      const props = {
        ...this.props,
        [targetProp]: this.insertGroupRowsToData(
          _.cloneDeep(this.props[sourceProp]),
          this.renderGroupRows()
        )
      };

      return <WrappedComponent {...props} />;
    }
  };

export default insertGroupRows;



// WEBPACK FOOTER //
// ./src/views/ReportPreview/HOCs/insertGroupRows.jsx